export type CustomerHistoryFilter = 'all' | 'cart' | 'ordered';

export interface CustomerHistoryArgs {
    customerId: string | number;
    page?: number;
    limit?: number;
    filter?: CustomerHistoryFilter;
    /** Optional `YYYY-MM-DD` bounds (the preview page passes its current range). */
    minDate?: string;
    maxDate?: string;
}

export const HISTORY_PAGE_SIZE = 200;

/** Legacy callers dispatch a bare customer id. */
export const normalizeHistoryArgs = (
    arg: CustomerHistoryArgs | string | number
): Required<Pick<CustomerHistoryArgs, 'customerId' | 'page' | 'limit' | 'filter'>> & Pick<CustomerHistoryArgs, 'minDate' | 'maxDate'> => {
    const base = typeof arg === 'object' && arg !== null ? arg : { customerId: arg };
    return {
        customerId: base.customerId,
        page: base.page || 1,
        limit: base.limit || HISTORY_PAGE_SIZE,
        filter: base.filter || 'all',
        minDate: base.minDate,
        maxDate: base.maxDate,
    };
};

/** One cache entry per customer + filter + range, independent of the page. */
export const historyKey = (arg: CustomerHistoryArgs | string | number): string => {
    const a = normalizeHistoryArgs(arg);
    return [a.customerId, a.filter, a.minDate || '', a.maxDate || ''].join('|');
};
